import { apiClient } from "@api/apiClient";

import { AgencyCountryResponse } from "./agencyCountry.interface";

const API_ENDPOINT = {
  getAgencyCountryData: "/edb/filter/regulatory-agency-country/",
};

export const agencyCountryApis = {
  getAgencyCountryData: async () => {
    const { data } = await apiClient.get<AgencyCountryResponse>(
      `${API_ENDPOINT.getAgencyCountryData}`,
    );
    return data;
  },
};
